import React from 'react';

import { useQuestionCommands } from '../../commands/CustomizationCommandsContext';
import { useLabels } from '../../i18n/useLabels';
import type { SectionViewModel } from '../../viewmodels/createSectionViewModel';
import { SortableList } from '../dnd/SortableList';
import { sectionTableId } from '../sections/sectionDomIds';
import { QuestionRow } from './QuestionRow';

import styles from './QuestionTable.scss';

type Props = {
  viewModel: Pick<SectionViewModel, 'name' | 'rows' | 'emptyMessage'>;
  sectionId: string;
};

export function QuestionTable({ viewModel, sectionId }: Props) {
  const labels = useLabels();
  const { reorder } = useQuestionCommands();
  const { rows } = viewModel;

  return (
    <div
      id={sectionTableId(sectionId)}
      role="table"
      aria-label={viewModel.name}
      className={styles.table}
    >
      <div role="row" className={styles.headerRow}>
        <div role="columnheader">{labels.questionsHeading}</div>
        <div role="columnheader">{labels.responseTypeHeading}</div>
      </div>
      <SortableList
        items={rows.map(row => ({ id: row.id, name: row.label }))}
        canReorder={rows.some(row => row.reorder.canReorder)}
        onReorder={(activeId, overId) => reorder(sectionId, activeId, overId)}
      >
        {rows.map(row => (
          <QuestionRow key={row.id} viewModel={row} />
        ))}
      </SortableList>
      {viewModel.emptyMessage && (
        <div role="row" className={styles.emptyRow}>
          <div role="cell" className={styles.emptyMessage}>
            {labels.formatMessage(viewModel.emptyMessage)}
          </div>
        </div>
      )}
    </div>
  );
}
